import { HotelDescription, LocationTabInfo } from './../hotel-single.component';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-hotel-single-description',
    templateUrl: 'hotel-description.component.html',
    styleUrls: ['hotel-description.component.css', 'hotel-description.component.scss']
})

export class HotelSingleDescriptionComponent implements OnInit {

    @Input() hotelDscription: HotelDescription;
    @Input() locations: LocationTabInfo;

    isReadMore: Boolean = false;

    constructor(@Inject(DOCUMENT) private document: Document) { }

    ngOnInit() {
    }

    triggerMenu(openClose: boolean) {
        const modal = <HTMLDivElement>document.getElementById('md-modalDescription');
        if (openClose) {
            this.document.body.setAttribute('style', 'overflow-y: hidden !important');
            modal.classList.add('md-show');
        } else {
            this.document.body.removeAttribute('style');
            modal.classList.remove('md-show');
        }
    }

    getKeys(mapObj) {
        return Array.from(mapObj.keys());
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    readMore() {

        /*const dots = document.getElementById('dots2');
        const moreText = document.getElementById('more2');
        const btnText = document.getElementById('myBtn2');
        const lang = document.getElementById('lang');

        if (dots.style.display === 'none') {
            this.triggerMenu(false);
            dots.style.display = 'inline';
            btnText.innerHTML = 'Read more';
            moreText.style.display = 'none';
            lang.style.display = 'none';
        } else {
            this.triggerMenu(true);
            dots.style.display = 'none';
            btnText.innerHTML = 'Read less';
            btnText.style.display = 'block';
            moreText.style.display = 'inline';
            lang.style.display = 'inline';
        }*/
    }
}
